var _path, _path2, _circle, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUserWhite(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.26953 14.0101H13.7266V15.4327H2.26953V14.0101Z",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.4241 14.0101V13.5524C14.4241 11.427 12.7011 9.70407 10.5757 9.70407H7.99719H5.41867C3.29328 9.70407 1.57031 11.427 1.57031 13.5524V14.0101",
    stroke: "#fff",
    strokeWidth: 1.44
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 7.99905,
    cy: 4.36671,
    r: 2.69702,
    stroke: "#fff",
    strokeWidth: 1.44
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2.2708 14.7106C2.08502 14.7106 1.90685 14.6368 1.77548 14.5054C1.64411 14.3741 1.57031 14.1959 1.57031 14.0101",
    stroke: "#fff",
    strokeWidth: 1.44101,
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.4271 14.0101C14.4271 14.1959 14.3533 14.3741 14.2219 14.5054C14.0905 14.6368 13.9123 14.7106 13.7266 14.7106",
    stroke: "#fff",
    strokeWidth: 1.44101,
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserWhite);
export default __webpack_public_path__ + "static/media/user_white.967e29b90214bea7928e69a3a98165b1.svg";
export { ForwardRef as ReactComponent };